export function formatViews(v: number): string {
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1).replace('.0', '') + 'M';
  if (v >= 1_000) return (v / 1_000).toFixed(1).replace('.0', '') + 'K';
  return String(v);
}

export function formatNum(v: number): string {
  return v.toLocaleString('ru-RU');
}

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });
}

/** Мусор из гугл-таблицы вместо ссылки: «#REF!», «#N/A», «#ЗНАЧ!»… —
 *  такое значение равносильно пустому (21.09: 25 акков с #REF! вели в никуда). */
export function isBrokenLink(v: string | null | undefined): boolean {
  if (!v) return true;
  const t = v.trim();
  return t === '' || t.startsWith('#') || !/^https?:\/\//i.test(t);
}

/** Профиль инсты открываем сразу на вкладке «Reels» — сотрудники смотрят
 *  именно выкладку, а не шапку профиля. Ссылку строим из юзернейма, если
 *  сохранённая битая или её нет. */
export function reelsUrl(igUrl: string | null | undefined, username?: string): string | null {
  if (isBrokenLink(igUrl)) {
    return username ? `https://www.instagram.com/${username}/reels/` : null;
  }
  const base = igUrl!.replace(/\/+$/, '').replace(/\/reels$/i, '');
  return `${base}/reels/`;
}

export function firstLetter(s: string): string {
  const c = s.trim().charAt(0);
  return c ? c.toUpperCase() : '?';
}

/** Человеческие названия полей для ленты событий. */
export const FIELD_LABELS: Record<string, string> = {
  created: 'создан',
  phone: 'телефон',
  model: 'модель',
  containerId: 'контейнер',
  username: 'юзернейм',
  igUrl: 'ссылка на акк',
  accountType: 'тип аккаунта',
  batch: 'пачка',
  cloneVersion: 'версия клона',
  creoName: 'крео',
  status: 'статус',
  warn: 'варн',
  warn18: 'варн 18+',
  country: 'страна',
  language: 'язык',
  geo: 'координата',
  decorated: 'оформление',
  poured: 'залито',
  link: 'линк',
  startDate: 'дата старта',
  banDate: 'дата бана',
  viewsCategory: 'категория просмотров',
  containerReplacements: 'замен в контейнере',
  creoReplaced: 'замена крео',
  creoReplaceReason: 'причина замены',
  note: 'заметка',
  reel_deleted: 'рилс удалён инстой',
};

/**
 * «Обновлено» для блоков с просмотрами: относительное время последнего
 * успешного парсинга. null = парсер ещё не присылал метрики.
 */
export function formatUpdated(iso: string | null): string {
  if (!iso) return 'парсинга ещё не было';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return 'только что';
  if (mins < 60) return `${mins} мин назад`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ч назад`;
  const days = Math.floor(hours / 24);
  if (days === 1) return `вчера, ${d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`;
  if (days < 7) return `${days} дн. назад`;
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
